__turbopack_context__.v({
  "contentAnimation": "UbmGTW_contentAnimation",
  "fadeInUp": "UbmGTW_fadeInUp",
  "imageAnimation": "UbmGTW_imageAnimation",
  "sectionAnimation": "UbmGTW_sectionAnimation",
});
